import { supabase } from '@/lib/supabase';

/**
 * Returns the original image URL without proxying
 * @param url The image URL
 * @param isForUpload Optional flag indicating if the URL is for an upload operation
 * @returns The original URL
 */
export const getProxiedImageUrl = async (url: string, isForUpload: boolean = false): Promise<string> => {
  // Simply return the original URL without any proxying
  return url || '';
};
